// Day-two "Manage Shopify" surface (shopify-manage mockup §180). Where the
// Shopify connection lives after onboarding: status, reconnect, and how to
// disconnect. Reached from Setup's "Manage store" and the connections list.
// Reconnect carries the store domain (2026-11-03): the connect screen then shows only Connect with Shopify.
// Status is read from the data-feeds schedules API (defensive about field
// casing); disconnect for the OAuth/real-time app is a Shopify-admin uninstall
// (canonical — Shopify then notifies our app/uninstalled + shop/redact).

import React from "react";
import { withRouter } from "react-router";
import ServiceFactory from "../../service";
import { OB_CSS } from "../onboarding/onboarding-css";
const feeds = api => {
  const S = ServiceFactory.getType(`/data-feeds${api}`, "product");
  return new S();
};
const safe = async (p, fb) => {
  try {
    return await p;
  } catch (e) {
    return fb;
  }
};
class ManageShopifyView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      schedule: null
    };
    this._alive = true;
  }
  componentWillUnmount() {
    this._alive = false;
  }
  async componentDidMount() {
    const list = await safe(feeds("/schedules").getAsync(), []);
    const arr = Array.isArray(list) ? list : list && list.data || [];
    const schedule = arr.find(s => String(s && (s.provider || s.Provider) || "").toLowerCase() === "shopify") || null;
    if (this._alive) this.setState({
      loading: false,
      schedule
    });
  }
  field(s, ...names) {
    for (const n of names) {
      if (s && s[n] != null && s[n] !== "") return s[n];
    }
    return null;
  }
  render() {
    const {
      loading,
      schedule
    } = this.state;
    const connected = !!schedule;
    let shop = null,
      last = null,
      freq = null,
      status = null;
    if (schedule) {
      status = this.field(schedule, "status", "Status");
      freq = this.field(schedule, "frequency", "Frequency");
      last = this.field(schedule, "lastRunDate", "LastRunDate", "lastRun", "LastRun");
      let settings = this.field(schedule, "settings", "Settings");
      try {
        if (typeof settings === "string") settings = JSON.parse(settings);
      } catch (e) {/* noop */}
      shop = settings && (settings.ShopifyShopDomain || settings.shopifyShopDomain) || null;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "ob-root"
    }, /*#__PURE__*/React.createElement("style", null, OB_CSS), /*#__PURE__*/React.createElement("div", {
      className: "ob-wrap",
      style: {
        maxWidth: 720
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "ob-eyebrow"
    }, "Manage \xB7 connections \xB7 Shopify"), /*#__PURE__*/React.createElement("div", {
      className: "ob-hrow"
    }, /*#__PURE__*/React.createElement("h2", null, "Shopify")), loading ? /*#__PURE__*/React.createElement("p", {
      className: "ob-hint"
    }, "Loading your Shopify connection\u2026") : /*#__PURE__*/React.createElement("div", {
      className: "ob-sec"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        marginBottom: 12
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: `ob-pill${connected ? "" : " warn"}`
    }, connected ? "Connected" : "Not connected"), shop && /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 13,
        color: "var(--ob-muted)"
      }
    }, shop)), connected ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 12.5,
        color: "var(--ob-muted)",
        lineHeight: 1.8
      }
    }, status && /*#__PURE__*/React.createElement("div", null, "Feed status: ", /*#__PURE__*/React.createElement("b", {
      style: {
        color: "var(--ob-fg-strong)"
      }
    }, String(status))), freq && /*#__PURE__*/React.createElement("div", null, "Sync frequency: ", /*#__PURE__*/React.createElement("b", {
      style: {
        color: "var(--ob-fg-strong)"
      }
    }, String(freq))), last && /*#__PURE__*/React.createElement("div", null, "Last sync: ", /*#__PURE__*/React.createElement("b", {
      style: {
        color: "var(--ob-fg-strong)"
      }
    }, String(last))), /*#__PURE__*/React.createElement("div", null, "Products, orders (as sales analytics), customers and inventory sync from your store.")), /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 14,
        display: "flex",
        gap: 8,
        flexWrap: "wrap"
      }
    }, /*#__PURE__*/React.createElement("button", {
      className: "ob-btn",
      onClick: () => this.props.history.push(shop ? `/Shopify?shop=${encodeURIComponent(shop)}` : "/Shopify")
    }, "Reconnect"), /*#__PURE__*/React.createElement("button", {
      className: "ob-btn ghost",
      onClick: () => this.props.history.push("/Social")
    }, "View Social insights")), /*#__PURE__*/React.createElement("p", {
      className: "ob-hint",
      style: {
        marginTop: 14
      }
    }, /*#__PURE__*/React.createElement("b", null, "To disconnect:"), " uninstall Plunk from your Shopify admin (", /*#__PURE__*/React.createElement("i", null, "Settings \u2192 Apps and sales channels"), "). Shopify notifies Plunk and we stop syncing; on the store-data-erasure request we also anonymize that store's customer identifiers. A read-only nightly-feed connection can be managed from ", /*#__PURE__*/React.createElement("a", {
      className: "ob-walk",
      style: {
        margin: 0
      },
      role: "button",
      onClick: () => this.props.history.push("/Data")
    }, "Manage Data"), ".")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
      className: "ob-hint",
      style: {
        margin: "4px 0 12px"
      }
    }, "Your store isn't connected yet. Connect to bring in products, orders, customers and inventory in one step."), /*#__PURE__*/React.createElement("button", {
      className: "ob-btn",
      onClick: () => this.props.history.push("/Shopify")
    }, "Connect Shopify")))));
  }
}
export default withRouter(ManageShopifyView);
export const ManageShopifyViewComponent = withRouter(ManageShopifyView);